<script>
  import { afterUpdate, createEventDispatcher, onMount } from 'svelte';
  import { focusOnTrigger } from './../action/focusElement.js';
  import { isLoadingAvailabilityData } from './../store/fetchAvailabilityData.js';
  import { isLoadingSkeleton } from './../store/store.js';

  export let elementId = 'toggle';
  export let label = 'Check availability';
  export let hidden = true;
  export let isFocus = false;

  const dispatch = createEventDispatcher();

  function toggle() {
    hidden = !hidden;
    dispatch('toggle', {
      isHidden: hidden,
    });
  }
</script>

<button
  class="bttn bg-teal-5 d-flex"
  class:bg-teal-9={!hidden}
  class:skeleton-effect-fade={$isLoadingSkeleton && $isLoadingAvailabilityData}
  type="button"
  aria-controls={`${elementId}-panel`}
  aria-expanded={!hidden}
  data-testid={`${elementId}-toggle`}
  on:click={toggle}
  use:focusOnTrigger={!hidden || isFocus}>
  <span class="d-flex flex-items-center">
    <svg
      class="opacity-50 mr-1 text-white"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 23"
      width="20"
      height="20"
      aria-hidden="true"
      focusable="false"
      ><path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.75 0a.75.75 0 01.75.75V3h9V.75a.75.75 0 111.5 0V3h2.75c.966 0 1.75.784 1.75 1.75v16a1.75 1.75 0 01-1.75 1.75H2.25A1.75 1.75 0 01.5 20.75v-16C.5 3.784 1.284 3 2.25 3H5V.75A.75.75 0 015.75 0zM20 9.5H2v11.25c0 .138.112.25.25.25h17.5a.25.25 0 00.25-.25V9.5z" /><path
        d="M18 13a1 1 0 11-2 0 1 1 0 012 0zM18 17a1 1 0 11-2 0 1 1 0 012 0zM12 13a1 1 0 11-2 0 1 1 0 012 0zM12 17a1 1 0 11-2 0 1 1 0 012 0zM6 13a1 1 0 11-2 0 1 1 0 012 0zM6 17a1 1 0 11-2 0 1 1 0 012 0z" /></svg>
    <span class="lh-default text-white">{label}</span>
  </span>
</button>
<div
  id={elementId}
  class="Box box-shadow-medium position-relative anim-fade-down mt-2"
  class:d-none={hidden}
  data-testid={`${elementId}-panel`}>
  <slot />
</div>
